module.exports = __webpack_public_path__ + "img/Support-skill-324.cdf61745.png";